var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 6C10.676 6 9.4 7.27599 9.4 8.85V9H7.45C7.20147 9 7 9.20147 7 9.45C7 9.69853 7.20147 9.9 7.45 9.9H17.05C17.2985 9.9 17.5 9.69853 17.5 9.45C17.5 9.20147 17.2985 9 17.05 9H15.1V8.85C15.1 7.27599 13.824 6 12.25 6ZM12.25 6.9C13.327 6.9 14.2 7.77304 14.2 8.85V9H10.3V8.85C10.3 7.77304 11.173 6.9 12.25 6.9Z",
    fill: "#ACACAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49798 10.6074C8.47447 10.36 8.25485 10.1785 8.00744 10.202C7.76002 10.2255 7.57851 10.4451 7.60202 10.6926C7.6587 11.2891 7.761 12.0242 7.89249 12.969L8.06142 14.1829C8.22292 15.3437 8.31451 16.0021 8.51266 16.5414C8.88142 17.5451 9.53923 18.3497 10.3852 18.7067C10.8446 18.9006 11.3701 18.9003 12.1524 18.9H12.3476C13.1299 18.9003 13.6554 18.9006 14.1148 18.7067C14.9608 18.3497 15.6186 17.5451 15.9873 16.5414C16.1855 16.0021 16.2771 15.3437 16.4386 14.1829L16.6075 12.969C16.739 12.0242 16.8413 11.2891 16.898 10.6926C16.9215 10.4452 16.74 10.2255 16.4926 10.202C16.2452 10.1785 16.0255 10.36 16.002 10.6074C15.9474 11.1822 15.8479 11.898 15.7146 12.8557L15.5572 13.9867C15.3829 15.2393 15.3031 15.7941 15.1426 16.231C14.833 17.0735 14.3183 17.6439 13.7649 17.8775C13.4947 17.9915 13.1675 18 12.25 18C11.3325 18 11.0053 17.9915 10.7351 17.8775C10.1817 17.6439 9.66698 17.0735 9.35744 16.231C9.19693 15.7941 9.1171 15.2393 8.94279 13.9867L8.78539 12.8557C8.65211 11.898 8.55259 11.1822 8.49798 10.6074Z",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSmall);
export default __webpack_public_path__ + "static/media/delete-small.ab974f6ba71a45870f271f8f1986e335.svg";
export { ForwardRef as ReactComponent };